// extracted by mini-css-extract-plugin
module.exports = {"logoutButton":"toggle-menu-list_component_logoutButton__vDPwr","profileIncompletionMark":"toggle-menu-list_component_profileIncompletionMark__W9igI"};